import { render, staticRenderFns } from "./BetonTvrtkaCRUD.vue?vue&type=template&id=38ea32d7&"
import script from "./BetonTvrtkaCRUD.vue?vue&type=script&lang=js&"
export * from "./BetonTvrtkaCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports